export default "__VITE_ASSET__D5i7_ehq__"